import { PersonEntity } from "@ots-frontend/ots-data";
import { useCallback, useEffect, useState } from "react";
import { BaseEntitySelect, BaseEntitySelectProps } from "../base-entity-select";

export type BasePersonSelectProps = Omit<
  BaseEntitySelectProps<PersonEntity>,
  "nameMapper"
> & {
  reverseName?: boolean;
};

export const BasePersonSelect = (props: BasePersonSelectProps) => {
  const { reverseName = true, entities, ...rest } = props;

  const [sortedData, setSortedData] = useState(entities);

  // name mapper
  const nameMapper = useCallback(
    (e: PersonEntity) => {
      if (reverseName) {
        return e.nameReverse;
      } else {
        return e.name;
      }
    },
    [reverseName]
  );

  // sort freight types by display name
  useEffect(() => {
    const sortedPersons = entities?.sort((a, b) =>
      nameMapper(a).localeCompare(nameMapper(b))
    );
    setSortedData(sortedPersons);
  }, [entities, nameMapper]);

  return (
    <BaseEntitySelect entities={sortedData} nameMapper={nameMapper} {...rest} />
  );
};
